import React, { useContext, useState, Fragment, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from '../context/User';
import { useTranslation } from 'react-i18next';

import {
  Button,
  Container,
  Dropdown,
  Icon,
  Menu,
  Segment,
} from 'semantic-ui-react';
import {
  API,
  getLogo,
  getSystemName,
  isAdmin,
  isMobile,
  showSuccess,
} from '../helpers';
import '../index.css';

// Header Buttons
let headerButtons = [
  {
    name: 'header.dashboard',
    to: '/dashboard',
    icon: 'chart bar',
  },
  {
    name: 'header.channel',
    to: '/channel',
    icon: 'sitemap',
    admin: true,
  },
  {
    name: 'header.token',
    to: '/token',
    icon: 'key',
  },
  {
    name: 'header.redemption',
    to: '/redemption',
    icon: 'dollar sign',
    admin: true,
    hasDropdown: true,
  },
  {
    name: 'header.user',
    to: '/user',
    icon: 'user',
    admin: true,
    hasDropdown: true,
  },
  {
    name: 'header.log',
    to: '/log',
    icon: 'book',
    hasDropdown: true,
  },
  {
    name: 'header.setting',
    to: '/setting',
    icon: 'setting',
    hasDropdown: true,
  },
];

if (localStorage.getItem('chat_link')) {
  headerButtons.splice(1, 0, {
    name: 'header.chat',
    to: '/chat',
    icon: 'comments',
  });
}

const Header = () => {
  const { t, i18n } = useTranslation();
  const [userState, userDispatch] = useContext(UserContext);
  let navigate = useNavigate();

  const [showSidebar, setShowSidebar] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    // 直接使用localStorage的值，不依赖i18n状态
    const savedLanguage = localStorage.getItem('i18nextLng');
    const language = savedLanguage || 'zh';
    console.log('Header: State initialization', { savedLanguage, finalLanguage: language });
    return language;
  });
  const systemName = getSystemName();
  const logo = getLogo();

  // 监听localStorage变化，确保状态同步
  useEffect(() => {
    const savedLanguage = localStorage.getItem('i18nextLng');
    if (savedLanguage && savedLanguage !== currentLanguage) {
      console.log('Header: Syncing localStorage language', { from: currentLanguage, to: savedLanguage });
      setCurrentLanguage(savedLanguage);
    }
  }, [currentLanguage]);

  async function logout() {
    setShowSidebar(false);
    await API.get('/api/user/logout');
    showSuccess('注销成功!');
    userDispatch({ type: 'logout' });
    localStorage.removeItem('user');
    navigate('/login');
  }

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const renderButtons = (isMobile) => {
    return headerButtons.map((button) => {
      if (button.admin && !isAdmin()) return <></>;
      
      if (isMobile) {
        return (
          <Menu.Item
            key={button.name}
            onClick={() => {
              navigate(button.to);
              setShowSidebar(false);
            }}
            style={{ fontSize: '15px' }}
          >
            {t(button.name)}
          </Menu.Item>
        );
      }

      // 处理有下拉菜单的按钮
      if (button.hasDropdown) {
        if (button.name === 'header.redemption') {
          return (
            <Dropdown
              key={button.name}
              item
              text={t(button.name)}
              pointing
              className='link item'
              style={{
                fontSize: '15px',
                fontWeight: '400',
                color: '#666',
              }}
            >
              <Dropdown.Menu>
                <Dropdown.Item
                  as={Link}
                  to={button.to}
                  style={{
                    fontSize: '15px',
                    fontWeight: '400',
                    color: '#666',
                  }}
                >
                  <Icon name={button.icon} style={{ marginRight: '4px' }} />
                  {t(button.name)}
                </Dropdown.Item>
                <Dropdown.Item
                  as={Link}
                  to='/topup'
                  style={{
                    fontSize: '15px',
                    fontWeight: '400',
                    color: '#666',
                  }}
                >
                  <Icon name='cart' style={{ marginRight: '4px' }} />
                  {t('header.topup')}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          );
        } else if (button.name === 'header.user') {
          return (
            <Dropdown
              key={button.name}
              item
              text={t(button.name)}
              pointing
              className='link item'
              style={{
                fontSize: '15px',
                fontWeight: '400',
                color: '#666',
              }}
            >
              <Dropdown.Menu>
                <Dropdown.Item
                  as={Link}
                  to={button.to}
                  style={{
                    fontSize: '15px',
                    fontWeight: '400',
                    color: '#666',
                  }}
                >
                  <Icon name={button.icon} style={{ marginRight: '4px' }} />
                  {t(button.name)}
                </Dropdown.Item>
                <Dropdown.Item
                  as={Link}
                  to='/group'
                  style={{
                    fontSize: '15px',
                    fontWeight: '400',
                    color: '#666',
                  }}
                >
                  <Icon name='users' style={{ marginRight: '4px' }} />
                  {t('header.group')}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          );
        } else if (button.name === 'header.log') {
          return (
            <Dropdown
              key={button.name}
              item
              text={t(button.name)}
              pointing
              className='link item'
              style={{
                fontSize: '15px',
                fontWeight: '400',
                color: '#666',
              }}
            >
              <Dropdown.Menu>
                <Dropdown.Item
                  as={Link}
                  to={button.to}
                  style={{
                    fontSize: '15px',
                    fontWeight: '400',
                    color: '#666',
                  }}
                >
                  <Icon name={button.icon} style={{ marginRight: '4px' }} />
                  {t(button.name)}
                </Dropdown.Item>
                <Dropdown.Item
                  as={Link}
                  to='/extended-logs'
                  style={{
                    fontSize: '15px',
                    fontWeight: '400',
                    color: '#666',
                  }}
                >
                  <Icon name='list alternate' style={{ marginRight: '4px' }} />
                  {t('header.extended_log')}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          );
        } else if (button.name === 'header.setting') {
          return (
            <Dropdown
              key={button.name}
              item
              text={t(button.name)}
              pointing
              className='link item'
              style={{
                fontSize: '15px',
                fontWeight: '400',
                color: '#666',
              }}
            >
              <Dropdown.Menu>
                <Dropdown.Item
                  as={Link}
                  to={button.to}
                  style={{
                    fontSize: '15px',
                    fontWeight: '400',
                    color: '#666',
                  }}
                >
                  <Icon name={button.icon} style={{ marginRight: '4px' }} />
                  {t(button.name)}
                </Dropdown.Item>
                <Dropdown.Item
                  as={Link}
                  to='/about'
                  style={{
                    fontSize: '15px',
                    fontWeight: '400',
                    color: '#666',
                  }}
                >
                  <Icon name='info circle' style={{ marginRight: '4px' }} />
                  {t('header.about')}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          );
        }
      }

      // 普通按钮
      return (
        <Menu.Item
          key={button.name}
          as={Link}
          to={button.to}
          style={{
            fontSize: '15px',
            fontWeight: '400',
            color: '#666',
          }}
        >
          <Icon name={button.icon} style={{ marginRight: '4px' }} />
          {t(button.name)}
        </Menu.Item>
      );
    });
  };

  // Add language switcher dropdown
  const languageOptions = [
    { key: 'zh', text: '中文', value: 'zh' },
    { key: 'en', text: 'English', value: 'en' },
  ];

  const changeLanguage = (language) => {
    console.log('Header: Changing language', { from: currentLanguage, to: language });
    i18n.changeLanguage(language);
    setCurrentLanguage(language);
    // 确保localStorage也更新
    localStorage.setItem('i18nextLng', language);
  };

  if (isMobile()) {
    return (
      <>
        <Menu
          borderless
          size='large'
          style={
            showSidebar
              ? {
                  borderBottom: 'none',
                  marginBottom: '0',
                  borderTop: 'none',
                  height: '51px',
                }
              : { borderTop: 'none', height: '52px' }
          }
        >
          <Container
            style={{
              width: '100%',
              maxWidth: isMobile() ? '100%' : '1200px',
              padding: isMobile() ? '0 10px' : '0 20px',
            }}
          >
            <Menu.Item as={Link} to='/'>
              <img src={logo} alt='logo' style={{ marginRight: '0.75em' }} />
              <div style={{ fontSize: '20px' }}>
                <b>{systemName}</b>
              </div>
            </Menu.Item>
            <Menu.Menu position='right'>
              <Menu.Item onClick={toggleSidebar}>
                <Icon name={showSidebar ? 'close' : 'sidebar'} />
              </Menu.Item>
            </Menu.Menu>
          </Container>
        </Menu>
        {showSidebar ? (
          <Segment style={{ marginTop: 0, borderTop: '0' }}>
            <Menu secondary vertical style={{ width: '100%', margin: 0 }}>
              {headerButtons.map((button) => {
                if (button.admin && !isAdmin()) return <></>;
                
                if (button.hasDropdown) {
                  if (button.name === 'header.redemption') {
                    return (
                      <Fragment key={button.name}>
                        <Menu.Item
                          onClick={() => {
                            navigate(button.to);
                            setShowSidebar(false);
                          }}
                          style={{ fontSize: '15px' }}
                        >
                          <Icon name={button.icon} style={{ marginRight: '4px' }} />
                          {t(button.name)}
                        </Menu.Item>
                        <Menu.Item
                          onClick={() => {
                            navigate('/topup');
                            setShowSidebar(false);
                          }}
                          style={{ fontSize: '15px', paddingLeft: '20px' }}
                        >
                          <Icon name='cart' style={{ marginRight: '4px' }} />
                          {t('header.topup')}
                        </Menu.Item>
                      </Fragment>
                    );
                  } else if (button.name === 'header.user') {
                    return (
                      <Fragment key={button.name}>
                        <Menu.Item
                          onClick={() => {
                            navigate(button.to);
                            setShowSidebar(false);
                          }}
                          style={{ fontSize: '15px' }}
                        >
                          <Icon name={button.icon} style={{ marginRight: '4px' }} />
                          {t(button.name)}
                        </Menu.Item>
                        <Menu.Item
                          onClick={() => {
                            navigate('/group');
                            setShowSidebar(false);
                          }}
                          style={{ fontSize: '15px', paddingLeft: '20px' }}
                        >
                          <Icon name='users' style={{ marginRight: '4px' }} />
                          {t('header.group')}
                        </Menu.Item>
                      </Fragment>
                    );
                  } else if (button.name === 'header.setting') {
                    return (
                      <Fragment key={button.name}>
                        <Menu.Item
                          onClick={() => {
                            navigate(button.to);
                            setShowSidebar(false);
                          }}
                          style={{ fontSize: '15px' }}
                        >
                          <Icon name={button.icon} style={{ marginRight: '4px' }} />
                          {t(button.name)}
                        </Menu.Item>
                        <Menu.Item
                          onClick={() => {
                            navigate('/about');
                            setShowSidebar(false);
                          }}
                          style={{ fontSize: '15px', paddingLeft: '20px' }}
                        >
                          <Icon name='info circle' style={{ marginRight: '4px' }} />
                          {t('header.about')}
                        </Menu.Item>
                      </Fragment>
                    );
                  }
                }
                
                return (
                  <Menu.Item
                    key={button.name}
                    onClick={() => {
                      navigate(button.to);
                      setShowSidebar(false);
                    }}
                    style={{ fontSize: '15px' }}
                  >
                    <Icon name={button.icon} style={{ marginRight: '4px' }} />
                    {t(button.name)}
                  </Menu.Item>
                );
              })}
              <Menu.Item style={{ textAlign: 'center', padding: '10px' }}>
                <Button.Group size='mini' compact>
                  <Button
                    basic={currentLanguage !== 'zh'}
                    color={currentLanguage === 'zh' ? 'blue' : undefined}
                    onClick={() => changeLanguage('zh')}
                    style={{
                      fontSize: '12px',
                      padding: '6px 8px',
                      minWidth: '40px'
                    }}
                  >
                    中
                  </Button>
                  <Button
                    basic={currentLanguage !== 'en'}
                    color={currentLanguage === 'en' ? 'blue' : undefined}
                    onClick={() => changeLanguage('en')}
                    style={{
                      fontSize: '12px',
                      padding: '6px 8px',
                      minWidth: '40px'
                    }}
                  >
                    EN
                  </Button>
                </Button.Group>
              </Menu.Item>
              <Menu.Item>
                {userState.user ? (
                  <Button onClick={logout} style={{ color: '#666666' }}>
                    {t('header.logout')}
                  </Button>
                ) : (
                  <>
                    <Button
                      onClick={() => {
                        setShowSidebar(false);
                        navigate('/login');
                      }}
                    >
                      {t('header.login')}
                    </Button>
                    <Button
                      onClick={() => {
                        setShowSidebar(false);
                        navigate('/register');
                      }}
                    >
                      {t('header.register')}
                    </Button>
                  </>
                )}
              </Menu.Item>
            </Menu>
          </Segment>
        ) : (
          <></>
        )}
      </>
    );
  }

  return (
    <>
      <Menu
        borderless
        style={{
          borderTop: 'none',
          boxShadow: 'rgba(0, 0, 0, 0.04) 0px 2px 12px 0px',
          border: 'none',
        }}
      >
        <Container
          style={{
            width: '100%',
            maxWidth: isMobile() ? '100%' : '1200px',
            padding: isMobile() ? '0 10px' : '0 20px',
          }}
        >
          <Menu.Item as={Link} to='/' className={'hide-on-mobile'}>
            <img src={logo} alt='logo' style={{ marginRight: '0.75em' }} />
            <div
              style={{
                fontSize: '18px',
                fontWeight: '500',
                color: '#333',
              }}
            >
              {systemName}
            </div>
          </Menu.Item>
          {renderButtons(false)}
          <Menu.Menu position='right'>
            <Menu.Item style={{ padding: '0 10px' }}>
              <Button.Group size='mini' compact>
                <Button
                  basic={currentLanguage !== 'zh'}
                  color={currentLanguage === 'zh' ? 'blue' : undefined}
                  onClick={() => changeLanguage('zh')}
                  style={{
                    fontSize: '12px',
                    padding: '6px 8px',
                    minWidth: '40px'
                  }}
                >
                  中
                </Button>
                <Button
                  basic={currentLanguage !== 'en'}
                  color={currentLanguage === 'en' ? 'blue' : undefined}
                  onClick={() => changeLanguage('en')}
                  style={{
                    fontSize: '12px',
                    padding: '6px 8px',
                    minWidth: '40px'
                  }}
                >
                  EN
                </Button>
              </Button.Group>
            </Menu.Item>
            {userState.user ? (
              <Dropdown
                text={userState.user.username}
                pointing
                className='link item'
                style={{
                  fontSize: '15px',
                  fontWeight: '400',
                  color: '#666',
                }}
              >
                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={logout}
                    style={{
                      fontSize: '15px',
                      fontWeight: '400',
                      color: '#666',
                    }}
                  >
                    {t('header.logout')}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <Menu.Item
                name={t('header.login')}
                as={Link}
                to='/login'
                className='btn btn-link'
                style={{
                  fontSize: '15px',
                  fontWeight: '400',
                  color: '#666',
                }}
              />
            )}
          </Menu.Menu>
        </Container>
      </Menu>
    </>
  );
};

export default Header;
